import React, { useState, useEffect } from "react";
import { Tabs, Tab } from "@appkit4/react-components/tabs";
import ApprovedPlans from "../../Plan/Analyst/WorkProgramCreation";
import "../../../styles/userManagement.css";
import APIService from "../../../services/apiAxiosService";
import useHttp from "../../../hooks/useHttp";
import displayToastMessage from "../../Common/Alert/displayToastMessage";

function WorkProgram() {
  const [currentTab, setCurrentTab] = useState("1");
  const [reset, setReset] = useState(false);
  const [assessment, setAssessment] = useState([]);
  const [controlWorkProgram, setControlWorkProgram] = useState();
  const [workProgramCategory, setWorkProgramCategory] = useState();
  const [loading, setLoading] = useState(false);
  const [workPrograms, setWorkPrograms] = useState();
  const [loader, setLoader] = useState(false);
  const { sendRequest: categoryListAPI } = useHttp();
  const { sendRequest: getAllControlWorkProgramAPI } = useHttp();
  const { sendRequest: getAssessmentList } = useHttp();
  const { sendRequest: getWorkPrograms } = useHttp();
  const { sendRequest: deleteWorkProgramRequestAPI } = useHttp();

  useEffect(() => {
    getControlWorkProgram();
    getAllCtrlWPCategory(); 
    getAssessments();
    getWPRequest();
  }, []);

  const getWPRequest = async () => {
    getWorkPrograms(APIService.getWorkPrograms(), (data) => {
      setWorkPrograms(data.MSG[0])
    })
  };

  const getAssessments = async () => {
    setLoader(true)
    getAssessmentList(APIService.getAssessmentList(), (res) => {
      if (res.CODE) {
        setAssessment(res.MSG[0]);
      }
    })
    setLoader(false)
  };

  const getControlWorkProgram = async () => {
    await getAllControlWorkProgramAPI(
      APIService.getAllControlWorkProgram(),
      (data) => setControlWorkProgram(data.MSG[0])
    );
  };
  const getAllCtrlWPCategory = async () => {
    await categoryListAPI(APIService.getAllCtrlWPCategoryList(), (data) =>
      setWorkProgramCategory(data.MSG)
    );
  };

  const handleTabs = (e, v) => {
    setCurrentTab(v);
    setReset(!reset);
  };

  const handleDelete = async (planID, userId, setModalVisible) => {
    setLoading(true);
    let data = {
      planID: planID,
      userID: userId,
      email: sessionStorage.getItem("email")
    }
    try {
      await deleteWorkProgramRequestAPI(APIService.deleteWorkProgramRequest(data), (result) => {
        if (result.CODE) {
          setLoading(false);
          displayToastMessage("Work Program Request deleted successfully", "success");
          getAssessments();
          setModalVisible(false);
        }
        else {
          setLoading(false);
          displayToastMessage("Something went wrong!", "error");
          setModalVisible(false);
        }
      })
    } catch (error) {
      setLoading(false);
      displayToastMessage("Something went wrong!", "error");
      setModalVisible(false);
    }
  };
  return (
    <div className="user-management-container">
      <Tabs
        defaultValue={currentTab}
        value={currentTab}
        onChange={handleTabs}
        className="a-tab-item-padding-10"
      >
        <Tab value="1" label="Define Work Program">
          {loader ? (
            <div className="row" id="preloader">
              <div className="col-12 col-lg-12 loader-margin text-center">
                <div className="a-loading a-primary a-m-10" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            </div>
          ) : (
            <ApprovedPlans
              AssessmentData={assessment}
              getAssessments={getAssessments}
              handleDelete={handleDelete}
            />
          )}
        </Tab>
      </Tabs>
    </div>
  );
}

export default WorkProgram;
